import React, { useState, useEffect } from "react";
import { axiosReq } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson";
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch";
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport";
import { MainAdminTables, AddModalWriters, DeleteModalWriters, MainAdminNewsesTopDropDown } from "../../components";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
const MainAdminWriters = () => {
    const [ban, setBan] = useState(false);

    const titleRow = ["نام", "نام خانوادگی", "کدملی", "شماره همراه", "نام کاربری", "رمز عبور"];
    const example = ["علیرضا", "بابایی", "0020163456", "09121452345", "alireza3401", "Aa@1234"];
    const showItems = [
        // { label: "همه نویسندگان", set: props.setLast }, 
        { label: "نویسندگان بلاک شده", set: setBan }];
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [writersList, setWritersList] = useState([]);
    const [data, setData] = useState();
    const [labelArt, setLabelArt] = useState();
    const [cats, setCats] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const itemsPerPage = 10;
      let navigate = useNavigate();

    const GetData = async () => {
        const writersData = await axiosReq("Admins/GetAuthor?page=" + page + "&&pageSize=" + row + "&&search=" + search+"&&IsBan="+ban, "get");
        console.log(writersData);
        setWritersList(writersData?.data);
        setCount(writersData?.count)
        const catsData = await axiosReq("Admins/GetCategories", "get");
        console.log(catsData);
        var catArr = [];
        catsData?.data?.map((item) => {
            catArr.push({ value: item.categoryId, label: item.categoryName });
        });
        setCats(catArr);
    };
   const auth = async () => {
                        const cookies = new Cookies();
                        var token = cookies.get('token');
                        console.log(token)
                        console.log(cookies.get('role'))
                        if (!token) {
                            navigate("/admin");
                        } else {
                            if( cookies.get('role')=="Admin")
                           {
                
                               GetData()
                           }
                
                            
                            else {
                                navigate("/admin");
                
                            }
                        }
                    }
    useEffect(() => {
        auth();
    }, [reCheck, search, page, row,ban]);


    

    const currentItems = writersList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div>
            <div className="p-[20px] flex justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={'black'} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">نویسندگان </p>
                </div>
                <div className="flex justify-start items-center">
                <div className="flex items-center mr-4">
                    <div className="w-[148px] ml-[15px]">
                        <p className="font-IRANYekanBold text-[15px] text-mainColor2">نمایش نویسندگان بر اساس :</p>
                    </div>
                    <div className="w-[223px] ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                        <MainAdminNewsesTopDropDown
                            mainText={labelArt?labelArt:"فیلتر"}
                            items={showItems}
                            set={setBan}
                            all={true}
                            setLabel={setLabelArt}
                            mainTextSize={15} /></div>
                </div>
                    <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e) => setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search /></button>
                    </div>
                    <button className="w-[121px] h-[40px] hoverBgYellow bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </button>
                    <button onClick={() => setShowAddModal(true)} className="w-[154px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن نویسنده</p>
                    </button>
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px]">
                <MainAdminTables type="author" detail={false} edit={true} block={true} deleted={true}
                    setShowEditModal={setShowEditModal} setShowBlockModal={setShowBlockModal} setShowDeleteModal={setShowDeleteModal}
                    data={data} setData={setData} page={page} setPage={setPage}
                    row={row} setRow={setRow} count={count}
                    titleRow={titleRow} writersList={currentItems} />

                
              
            </div>

            {showAddModal ? <AddModalWriters title={'افزودن نویسنده جدید'} buttonName={'ثبت'} setShowModal={setShowAddModal} reCheck={reCheck} setRecheck={setRecheck} cats={cats} /> : null}
            {showEditModal ? <AddModalWriters title={'ویرایش'} buttonName={'ویرایش'} setShowModal={setShowEditModal} data={data} reCheck={reCheck} setRecheck={setRecheck} cats={cats} /> : null}
            {showDeleteModal ? <DeleteModalWriters title={'حذف کاربر'} buttonName={'حذف'} text={'آیا از حذف کاربر انتخاب شده اطمینان دارید ؟'} setShowModal={setShowDeleteModal} data={data} reCheck={reCheck} type={"author"} setRecheck={setRecheck} /> : null}
            {showBlockModal ? <DeleteModalWriters title={'بلاک کاربر'} buttonName={'بلاک'} text={'آیا از بلاک کاربر انتخاب شده اطمینان دارید ؟'} setShowModal={setShowBlockModal} data={data} reCheck={reCheck} type={"author"} setRecheck={setRecheck} kind={"block"} /> : null}
        </div>
    );
};

export default MainAdminWriters;